var Moment = function (time) {
    this.time = new Date(time);
}
Moment.prototype = {
    formatTime(format = "yyyy-MM-dd hh:mm:ss") {
        /*
         * eg:format="yyyy-MM-dd hh:mm:ss";
         */
        var o = {
            "M+": this.time.getMonth() + 1,
            "d+": this.time.getDate(),
            "h+": this.time.getHours(),
            "m+": this.time.getMinutes(),
            "s+": this.time.getSeconds(),
            "q+": Math.floor((this.time.getMonth() + 3) / 3),
            "S": this.time.getMilliseconds()
        };
        if (/(y+)/.test(format)) {
            format = format.replace(RegExp.$1, (this.time.getFullYear() + "")
                .substr(4 - RegExp.$1.length));
        }
        for (var k in o) {
            if (new RegExp("(" + k + ")").test(format)) {
                format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k]
                    : ("00" + o[k]).substr(("" + o[k]).length));
            }
        }
        return format;
    },
    fixTime() {
        let that = this;
        var showStr = '';
        var now = new Date().getTime();
        var delta = Number(now) - Number(that.time);
        var perMin = 60 * 1000;
        var perHour = 60 * perMin;
        var perDay = 24 * perHour;
        if (delta > 0) {
            if (delta < perMin) {
                showStr = '刚刚';
            } else if (perMin <= delta && delta < perHour) {
                showStr = Math.floor(delta / perMin) + '分钟前';
            } else if (perHour <= delta && delta < perDay) {
                showStr = Math.floor(delta / perHour) + '小时前';
            } else {
                showStr = that.formatTime('MM-dd hh:mm');
            }
            return showStr;
        } else {
            // console.warn('传入起始时间早于当前时间');
        }

    }
}

export default Moment;


// WEBPACK FOOTER //
// ./src/_utils/moment.js